import { createSelector } from 'reselect'

export const getAddonsLoading = createSelector(
	(state) => state && state.user && state.user.profile && state.user.profile.addons ?
	state.user.profile.addons.isLoading : false,
  (addonsLoading) => addonsLoading
)
